import { Component, input, OnInit, output, signal } from '@angular/core';
import { SafeUrl } from '@angular/platform-browser';
import { FileResponse } from '@app/models/shared.models';
import { ImgService } from '@app/services/file/img.service';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-img-gallery-item',
  imports: [TranslatePipe],
  templateUrl: './img-gallery-item.component.html',
  styleUrl: './img-gallery-item.component.scss',
})
export class ImgGalleryItemComponent implements OnInit {
  image = input.required<FileResponse>();
  imgSrc = signal<SafeUrl | null>(null);
  galleryId = input.required<string>();
  loaded = output<void>();

  constructor(private imgService: ImgService) {}

  ngOnInit(): void {
    this.getImgUrl(this.image().id);
  }

  getImgUrl(imageId: string) {
    this.imgService.loadImage(imageId).then((imgUrl) => {
      if (imgUrl !== undefined) {
        this.imgSrc.set(imgUrl);
        this.loaded.emit();
      }
    });
  }
}
